import type { Variety } from '@protector/entities/crop/models';
import type { Dictionary, UUID } from '@protector/utils/types';
import type { Observable } from 'rxjs';
import { concat, forkJoin } from 'rxjs';
import { toArray } from 'rxjs/operators';
import type { Product } from '@protector/entities/product/models';

export const createReduxPage = (content: Dictionary<unknown>[]) => {
  return {
    content,
    empty: !content.length,
    first: true,
    last: true,
    number: 0,
    number_of_elements: content.length,
    size: content.length,
    total_elements: content.length,
    total_pages: 1
  };
};

export const createReduxEntities = (content: { [key: string]: unknown; id: string }[]) => {
  return content.reduce((acc, c) => {
    return {
      ...acc,
      [c.id]: c
    };
  }, {});
};

export const getObservables = <T>(observables: Observable<T>[], useAsync: boolean): Observable<T[]> => {
  if (useAsync) {
    return forkJoin(observables);
  }
  return concat(...observables).pipe(toArray());
};

export const shouldReloadProducts = (products: Dictionary<Product>, companyId: UUID, loadedCompanyId?: UUID) => {
  return !Object.keys(products).length && companyId !== loadedCompanyId;
};

export const shouldReloadVarieties = (varieties: Variety[] | undefined, companyId: UUID, loadedCompanyId?: UUID): boolean => {
  if (!varieties) return true;

  return !varieties.length || companyId !== loadedCompanyId;
};
